export const RouteTable = {
  policies: "/policies",
  absenceReasons: "/policies/absence-reasons",
  questions: "/policies/questions",
};
